var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E71817",
    fillRule: "evenodd",
    d: "M9.392 12.522V5.217l6.26 3.665-6.26 3.64zM23.76 3.827s-.235-1.738-.954-2.504C21.893.318 20.87.313 20.401.255 17.043 0 12.005 0 12.005 0h-.01S6.957 0 3.599.255c-.47.059-1.492.063-2.406 1.068C.474 2.09.24 3.827.24 3.827S0 5.867 0 7.908v1.914c0 2.041.24 4.082.24 4.082s.234 1.738.953 2.503c.914 1.005 2.113.974 2.647 1.078 1.92.194 8.16.254 8.16.254s5.043-.008 8.401-.263c.47-.06 1.492-.064 2.405-1.069.72-.765.954-2.503.954-2.503s.24-2.04.24-4.082V7.908c0-2.04-.24-4.081-.24-4.081z"
  })));
}

export default SvgYoutube;